import { watchEffect, computed } from 'vue';
import { round } from 'mathjs';
import numberFormat from '@/helpers/numberFormat.ts';

export function usePrecioCalc(form) {
  const total = computed(() => numberFormat(form.total));

  const subtotal = computed(() =>
    numberFormat(form.cantidad * form.precio_unitario)
  );
  const precio_unitario = computed(() => numberFormat(form.precio_unitario));
  const descuento_comercial = computed(() =>
    numberFormat(form.descuento_comercial, true)
  );
  const descuento_estrategico = computed(() =>
    numberFormat(form.descuento_estrategico, true)
  );
  const totalAccesoriosFormatted = computed(() =>
    numberFormat(form.accesorios.reduce((x, y) => x + Number(y.total), 0))
  );
  const ancho = computed(() => numberFormat(form.ancho, true));
  const totalFormatted = computed(() => numberFormat(form.total));
  const cantidadFormatted = computed(() => numberFormat(form.cantidad, true));
  watchEffect(() => {
    const cantidad_piezas = form.cantidad_piezas;
    const largo_pieza = form.largo_pieza;
    const ancho = form.ancho;
    const precio_unitario = round(form.precio_unitario, 2);
    const descuento_comercial = round(form.descuento_comercial, 2);
    const descuento_estrategico = round(form.descuento_estrategico, 2);
    const sumAccesorios = form?.accesorios?.reduce((x, y) => x + round(Number(y.total), 2), 0) || 0;
    const totalAccesorios = round(sumAccesorios, 2) || 0;
    let puConDescuento = 0;
    let descuentoEstrategico = 0;
    let descuentoComercial = 0;
    let cantidad = form.cantidad ? round(form.cantidad, 2) : 0;
    if (form.cantidad_piezas && form.largo_pieza && form.ancho) {
      cantidad = cantidad_piezas * round(largo_pieza * ancho, 2);
    }
    form.cantidad = cantidad;
    puConDescuento = precio_unitario;
    if (descuento_comercial) {
      descuentoComercial = round(
        (puConDescuento / 100) * descuento_comercial,
        2
      );
      puConDescuento = puConDescuento - descuentoComercial;
    }
    if (descuento_estrategico) {
      descuentoEstrategico = round(
        (puConDescuento / 100) * descuento_estrategico,
        2
      );
      puConDescuento = puConDescuento - descuentoEstrategico;
    }
    form.total = round(cantidad * puConDescuento + totalAccesorios, 2);

  });
  return {
    ancho,
    descuento_comercial,
    descuento_estrategico,
    precio_unitario,
    subtotal,
    total,
    totalFormatted,
    totalAccesoriosFormatted,
    cantidadFormatted,
  };
}
